export default __webpack_public_path__ + "static/media/close.e4ab8e48.svg";